import { Request, RequestCategory } from "@/types/research.types";

function isCategoryReachable(
  category: RequestCategory,
  categoryMap: Map<string, RequestCategory>,
  visited = new Set<string>()
): boolean {
  if (category.parent_id == null || category.parent_id === "default") return true;
  if (visited.has(category._id)) return false;
  visited.add(category._id);
  const parent = categoryMap.get(category.parent_id);
  if (!parent) return false;
  return isCategoryReachable(parent, categoryMap, visited);
}

function isCategoryIdReachable(
  categoryId: string | null,
  categoryMap: Map<string, RequestCategory>,
  visited = new Set<string>()
): boolean {
  if (categoryId == null || categoryId === "default") return true;
  if (visited.has(categoryId)) return false;
  visited.add(categoryId);
  const parent = categoryMap.get(categoryId);
  if (!parent) return false;
  if (parent.parent_id == null || parent.parent_id === "default") return true;
  return isCategoryIdReachable(parent.parent_id, categoryMap, visited);
}

export function filterCategories(
  categories: RequestCategory[],
  searchQuery: string
): RequestCategory[] {
  const categoryMap = new Map(categories.map((c) => [c._id, c]));
  const reachableCategories = categories.filter((c) => isCategoryReachable(c, categoryMap));
  if (!searchQuery.trim()) return reachableCategories;
  return reachableCategories.filter(
    (cat) =>
      cat.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      (cat.description ?? "").toLowerCase().includes(searchQuery.toLowerCase())
  );
}

export function filterRequests(
  requests: Request[] | undefined,
  categories: RequestCategory[],
  searchQuery: string
): Request[] {
  if (requests == null) return [];
  if (!searchQuery.trim()) return [];
  const categoryMap = new Map(categories.map((c) => [c._id, c]));
  return requests.filter((req) => {
    const matchesSearch =
      req.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      req.content.toLowerCase().includes(searchQuery.toLowerCase());
    if (!matchesSearch) return false;
    return isCategoryIdReachable(req.category_id, categoryMap);
  });
}
